import posthog from 'posthog-js';

import { clientCookies } from '@/shared/constants/cookies';
import { useConfigStore } from '@/shared/pinia/modules/config';
import { useUserStore } from '@/shared/pinia/modules/user';
import { clearCookie, getCookie, setCookie } from '@/shared/utils/cookie';
import { hashUserData } from '@/shared/utils/tracking';

const userId = () => {
  const loggedInDistinctId = getCookie(clientCookies.PRODUCT_ANALYTICS_USER_ID);
  const distinctId = getCookie(clientCookies.PRODUCT_ANALYTICS_CLIENT_ID);

  if (loggedInDistinctId) {
    return loggedInDistinctId;
  }

  if (distinctId) {
    return distinctId;
  }
};

const userProperties = () => {
  const userStore = useUserStore();
  const configStore = useConfigStore();

  const consentTrackedProperties = {
    country: configStore.countryCode,
    language: configStore.language
  };

  const alwaysTrackedProperties = {
    isLoggedIn: userStore.isLogged
  };

  if (!window.Shopify.customerPrivacy?.preferencesProcessingAllowed()) {
    return alwaysTrackedProperties;
  }

  return {
    ...alwaysTrackedProperties,
    ...consentTrackedProperties
  };
};

const refreshCookieStorage = () => {
  const userStore = useUserStore();

  if (userStore.customer?.uuid) {
    return setCookie(
      clientCookies.PRODUCT_ANALYTICS_USER_ID,
      hashUserData(userStore.customer.uuid)
    );
  }
  clearCookie(clientCookies.PRODUCT_ANALYTICS_USER_ID);

  const clientId = getCookie(clientCookies.PRODUCT_ANALYTICS_CLIENT_ID);
  if (!clientId) {
    setCookie(clientCookies.PRODUCT_ANALYTICS_CLIENT_ID, crypto.randomUUID());
  }
};

const aliasUser = () => {
  const loggedInDistinctId = getCookie(clientCookies.PRODUCT_ANALYTICS_USER_ID);
  const distinctId = getCookie(clientCookies.PRODUCT_ANALYTICS_CLIENT_ID);

  if (loggedInDistinctId && distinctId) {
    posthog.alias(loggedInDistinctId, distinctId);
    clearCookie(clientCookies.PRODUCT_ANALYTICS_CLIENT_ID);
  }
};

export const initPostHog = () => {
  if (!window.Hobbii?.flags.enableBetaProductAnalytics) {
    return;
  }

  setTimeout(() => {
    refreshCookieStorage();

    const distinctId = userId();

    if (!distinctId) {
      return;
    }

    posthog.init(import.meta.env.VITE_POSTHOG_API_KEY, {
      api_host: import.meta.env.VITE_POSTHOG_API_HOST,
      defaults: '2025-05-24',
      person_profiles: 'always'
    });

    posthog.identify(distinctId, userProperties());
    aliasUser();

    window.posthog = posthog;

    if (window.Shopify.customerPrivacy?.analyticsProcessingAllowed()) {
      posthog.opt_in_capturing();
    } else {
      posthog.opt_out_capturing();
    }
  }, 200);
};
